import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';


export default class TableRowSelect extends Component {
    static propTypes = {
        item: PropTypes.object,
        isChecked: PropTypes.bool,
        onChange: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.toggleSelectItem = this.toggleSelectItem.bind(this);
    }

    toggleSelectItem() {
        this.props.onChange(this.props.item)
    }

    render() {
        return <input type="checkbox"
                      checked={this.props.isChecked}
                      onChange={this.toggleSelectItem} />
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/Components/TableRowSelect.js